/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OperationalIssue } from "./OperationalIssue";
import {
  OperationalIssueFromJSON,
  OperationalIssueFromJSONTyped,
  OperationalIssueToJSON,
  OperationalIssueToJSONTyped,
} from "./OperationalIssue";

/**
 *
 * @export
 * @interface OperationalIssuesResponse
 */
export interface OperationalIssuesResponse {
  /**
   *
   * @type {Array<OperationalIssue>}
   * @memberof OperationalIssuesResponse
   */
  issues: Array<OperationalIssue>;
}

/**
 * Check if a given object implements the OperationalIssuesResponse interface.
 */
export function instanceOfOperationalIssuesResponse(
  value: object,
): value is OperationalIssuesResponse {
  if (!("issues" in value) || value["issues"] === undefined) return false;
  return true;
}

export function OperationalIssuesResponseFromJSON(
  json: any,
): OperationalIssuesResponse {
  return OperationalIssuesResponseFromJSONTyped(json, false);
}

export function OperationalIssuesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationalIssuesResponse {
  if (json == null) {
    return json;
  }
  return {
    issues: (json["issues"] as Array<any>).map(OperationalIssueFromJSON),
  };
}

export function OperationalIssuesResponseToJSON(
  json: any,
): OperationalIssuesResponse {
  return OperationalIssuesResponseToJSONTyped(json, false);
}

export function OperationalIssuesResponseToJSONTyped(
  value?: OperationalIssuesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    issues: (value["issues"] as Array<any>).map(OperationalIssueToJSON),
  };
}
